<template>
  <div class="horizontal-timeline" v-if="Object.keys(order).length">
    <order-instructions :order="order"></order-instructions>
    <ul>
      <li>
        <div class="media">
          <div class="timeline-icon">
            <svg width="16" height="16" fill="white">
              <use xlink:href="#store" />
            </svg>
          </div>
          <div class="media-body">
            <h6>{{ _T('Store address') }}</h6>
            <h5 v-if="storeAddress">
              <RestaurantAddress :address="storeAddress" />
            </h5>
            <h5 v-else>
              {{ _T('No address found') }}
            </h5>
          </div>
        </div>
      </li>
      <li>
        <div class="media">
          <div class="timeline-icon">
            <img src="/images/svg/food-details/user.svg" alt="" />
          </div>
          <div class="media-body">
            <h6>{{ _T('Delivery Address') }}</h6>
            <h5>{{ formattedDeliveryAddress() }}</h5>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RestaurantAddress from '@/components/Blocks/Util/RestaurantAddress'
export default {
  name: 'HistoryHorizontalHeader',
  props: {
    order: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
  },
  components: {
    RestaurantAddress,
    OrderInstructions: () =>
      import('@/components/Collections/Order/OrderInstructions.vue'),
  },
  computed: {
    ...mapGetters([
      '_T',
      '_T_DB',
      'deliveryAreaName',
      'find_store_by_main_id',
      'formatOrderAddress',
      'find_store_by_main_id',
    ]),
    storeAddress() {
      return this.find_store_by_main_id(this.order.store_id)
    },
  },
  methods: {
    formattedDeliveryAddress() {
      return this.formatOrderAddress(this.order)
    },
  },
}
</script>

<style lang="scss" scoped>
.horizontal-timeline {
  padding: $px30 0;
  border-top: $px1 solid $light-border;
  ul {
    display: flex;
    position: relative;

    &:after {
      position: absolute;
      content: '';
      border-top: $px2 dashed $light-border;
      width: 88%;
      height: 100%;
      top: 47%;
      left: 0;
      z-index: -1;
    }

    li {
      padding: $px20;
      border: $px1 solid $light-border;
      border-radius: $px4;
      width: 100%;
      background-color: $white;

      + li {
        margin-left: calc(
          #{$px75} + (106 - 75) * ((100vw - #{$px320}) / (1920 - 320))
        );
      }

      .media {
        align-items: center;

        .timeline-icon {
          width: $px40;
          height: $px40;
          border-radius: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: $px16;
          }
        }

        .media-body {
          padding-left: $px18;

          h6 {
            font-weight: 600;
            line-height: $px22;
            letter-spacing: 0.005em;
            color: $light-font;
            margin-bottom: 0;
          }

          h5 {
            font-weight: 600;
            margin-bottom: 0;
          }
        }
      }

      &:first-child {
        .media {
          .timeline-icon {
            background-color: $warning-color;
            border: $px4 solid lighten(red, 30%);

            img {
              margin-left: $px2;
            }
          }
        }
      }

      &:last-child {
        .media {
          .timeline-icon {
            background-color: $tertiary-color;
            border: $px4 solid $tertiary-light;
          }
        }
      }
    }
  }
  @media (max-width: 1199px) {
    ul {
      li {
        padding: $px15;
      }
    }
  }
  @media (max-width: 991px) {
    ul {
      display: block;
      &:after {
        border-left: $px2 dashed $light-border;
        border-top: none;
        top: 0;
        left: $px35;
      }
      li {
        + li {
          margin-left: 0;
          margin-top: $px40;
        }
        .media {
          .media-body {
            padding-left: $px10;
          }
        }
      }
    }
  }
}
</style>
